import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { clearTypeahed, fetchTypeaheadInfrastructureUnitForFilter } from '../../../actions';
import MultiTypeahead from './MultiTypeahead';
import renderMultiSuggestion from '../RenderMultiSuggestion';

class LicensesIuMultiTypeahead extends Component {
    static propTypes = {
        fetchTypeaheadInfrastructureUnitForFilter: PropTypes.func,
        clearTypeahed: PropTypes.func.isRequired,
        suggestions: PropTypes.array,
        error: PropTypes.string,
        onChangeSuggestion: PropTypes.func,
        labelId: PropTypes.string,
        renderMultiSuggestion: PropTypes.func,
    };

    static defaultProps = {
        suggestions: [],
        labelId: 'infrastructureUnit',
        renderMultiSuggestion
    };

    handleSuggestionsFetchRequested = term => {
        this.props.fetchTypeaheadInfrastructureUnitForFilter(LicensesIuMultiTypeahead.name, { term });
    };

    render() {
        const { suggestions,
            value,
            onChangeSuggestion,
            clearTypeahed,
            renderMultiSuggestion,
            error,
            labelId,
            t } = this.props;

        const options = suggestions.map(iu => ({
            label: `IN:${iu.inventoryNumber || '--'} SN:${iu.serialNumber || '--'}`,
            value: iu.id
        }));

        return (
            <MultiTypeahead
                animatedPlaceholder
                options={options}
                isMulti
                value={value}
                error={error}
                titleId={labelId}
                selectFilterOption={() => true}
                handleSuggestionsClearRequested={clearTypeahed}
                handleSuggestionsFetchRequested={this.handleSuggestionsFetchRequested}
                onChangeSuggestion={onChangeSuggestion}
                formatOptionLabel={renderMultiSuggestion}
                t={t}
            />
        );
    }
}

const mapStateToProps = ({ typeahead }) => ({
    suggestions:
        typeahead.source === LicensesIuMultiTypeahead.name ?
            typeahead.list : LicensesIuMultiTypeahead.defaultProps.suggestions
});

export default connect(mapStateToProps, {
    fetchTypeaheadInfrastructureUnitForFilter,
    clearTypeahed
})(LicensesIuMultiTypeahead);
